<template>
    <div id="pagos-header">
        <div id="sig-container" class="full form-horizontal">
                <div class="widget">
                    <div class="widget-content widget-content-mini themed-background-info text-light-op"> <span class="float-right text-muted"><i class="fa fa-check"></i></span>Configuración de busqueda</div>
                    <div class="widget-content border-bottom themed-background-muted text-center">

                        <div class="form-group">
                            <label class="control-label col-lg-3 col-md-2" v-text="'Intermediario'"></label>
                            <div class="col-lg-12 col-md-12">
                                <select class="form-control" id="datos_cliente" v-model="campanaParams.cliente_id">
                                    <option :value='null'>Seleccione el intermediario</option>
                                    <option v-for="cliente in clientes" :value="cliente.id">{{cliente.nombre}}</option>
                                </select>
                            </div>
                        </div>

                        <div class="form-group">
                            <label class="control-label col-lg-3 col-md-2" v-text="'Estado del acuerdo de pago'"></label>
                            <div class="col-lg-12 col-md-12">
                                <select class="form-control" id="datos_cliente" v-model="campanaParams.estado_acuerdo_pago">
                                    <option :value='null'>Seleccione estado de acuerdo de pago</option>
                                    <option v-for="estado in estados_acuerdo_pago" :value="estado.id">{{estado.valor}}</option>
                                </select>
                            </div>
                        </div>

                        <div class="form-group">
                            <label class="control-label col-lg-3 col-md-2" v-text="'Número de la gestion'"></label>
                            <div class="col-lg-12 col-md-12">
                                <input type="text" id="gestion_id" v-model.trim="campanaParams.gestion_id" class="form-control" placeholder="# de la gestión">
                            </div>
                        </div>

                        <div class="form-actions">
                            <button class="btn btn-primary" @click="getCampana()">Aplicar</button>&nbsp;
                            <button class="btn btn-primary" @click="descargarConsulta()">Descargar excel</button>
                        </div>
                    </div>
                </div>

                <div>
                    <div class="loader" v-if="loading"><i class="fa fa-spinner fa-2x fa-spin text-info"></i></div>
                    <table-component :data="llamada_campania">
                        <table-column slot="label" :label="'Cedula'" v-bind:value="'cedula'"></table-column>
                        <table-column slot="label" :label="'Pagare'" v-bind:value="'pagare'"></table-column>
                        <table-column slot="label" :label="'Id_garantia'" v-bind:value="'id_garantia'"></table-column>
                        <table-column slot="label" :label="'Tipo Registro'" v-bind:value="'tipo_registro'"></table-column>
                        <table-column slot="label" :label="'Nombre Contacto'" v-bind:value="'nombre_contacto'"></table-column>
                        <table-column slot="label" :label="'Nombre'" v-bind:value="'nombre'"></table-column>
                        <table-column slot="label" :label="'Telefono'" v-bind:value="'telefono'"></table-column>
                        <table-column slot="label" :label="'Telefono2'" v-bind:value="'telefono2'"></table-column>
                        <table-column slot="label" :label="'Celular'" v-bind:value="'celular'"></table-column>
                        <table-column slot="label" :label="'Municipio'" v-bind:value="'municipio'"></table-column>
                        <table-column slot="label" :label="'Nit Intermediario'" v-bind:value="'nit_intermediario'"></table-column>
                        <table-column slot="label" :label="'Intermediario'" v-bind:value="'intermediario'"></table-column>
                        <table-column slot="label" :label="'Convenio'" v-bind:value="'convenio'"></table-column>
                        <table-column slot="label" :label="'Pagado Fga'" v-bind:value="'pagado_fga'"></table-column>
                        <table-column slot="label" :label="'Fecha_pago'" v-bind:value="'fecha_pago'"></table-column>
                        <table-column slot="label" :label="'Codigo Gestion'" v-bind:value="'codigo_gestion'"></table-column>
                        <table-column slot="label" :label="'Fecha Gestion'" v-bind:value="'fecha_gestion'"></table-column>
                        <table-column slot="label" :label="'Fecha Ultimo Abono De La Deuda'" v-bind:value="'fecha_ultimo_abono'"></table-column>
                        <table-column slot="label" :label="'Saldo Real'" v-bind:value="'saldo_real'"></table-column>
                        <table-column slot="label" :label="'Total Abonado'" v-bind:value="'total_abonado'"></table-column>
                </table-component>
                </div>
        </div>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex'
     import FileSaver from 'file-saver';
     import XLSX from 'xlsx';

    export default {
        data () {
            return {
                campanaParams: {
                    cliente_id: null,
                    gestion_id: null,
                    estado_acuerdo_pago: null,
                    paginar: false
                },
                estados_acuerdo_pago: [{
                    'id': "ACTIVO",
                    'valor': "ACTIVO"
                },
                {
                    'id': "INACTIVO",
                    'valor': "INACTIVO"
                }
                ],
            }
        },
        components: {
            TableComponent: () => import('@@/components/table/TableComponent'),
            TableColumn: () => import('@@/components/table/TableColumn'),
        },
        computed: {
            ...mapGetters({'clientes': 'cliente/clientes', 'loading': 'campana/loading'}),
            llamada_campania() {
                return this.$store.getters['campana/campana']
            },
        },
        methods: {
            getCliente() {
                this.$store.dispatch('index', {endpoint: 'cliente'})
                .then((response) => {
                    if (response.datos.length > 0){
                        this.$store.dispatch('cliente/refresh_clientes', response.datos)
                    } else {
                        console.log('no se encuentran clientes registrados');
                    }
                })
                .catch(() => {
                    this.$notify({
                        title: 'Advertencia!',
                        type: 'danger',
                        content: 'Se ha presentado un error realizando su consulta',
                    })
                })
            },
            getCampana() {
                this.$store.commit('campana/setLoading', true);
                this.$store.dispatch('index', {endpoint: 'informes/lista-campana', params: this.campanaParams})
                .then((response) => {
                    console.log(response.datos.length);
                    if (response.datos.length > 0){
                        this.$store.dispatch('campana/refresh_campana', response.datos)
                        this.$store.commit('campana/setLoading', false);
                    } else {
                        this.$notify({
                            title: 'Advertencia!',
                            type: 'warning',
                            content: 'No se encontrarón registros para este criterio de busqueda',
                        })
                        this.$store.dispatch('campana/refresh_campana', []);
                        this.$store.commit('campana/setLoading', false);
                    }
                })
                .catch(() => {
                    this.$notify({
                        title: 'Advertencia!',
                        type: 'danger',
                        content: 'Se ha presentado un error realizando su consulta',
                    })
                    this.$store.commit('campana/setLoading', false);
                    this.$store.dispatch('campana/refresh_campana', []);
                })
            },
            descargarConsulta() {
                var d = new Date();
                var twoDigitMonth = d.getMonth().length + 1 === 1 ? d.getMonth() + 1 : '0' + (d.getMonth() + 1);
                var twoDigitDate = d.getDate() + "";
                if (twoDigitDate.length == 1) twoDigitDate = "0" + twoDigitDate;
                var date = d.getFullYear() + '_' + twoDigitMonth + '_' + twoDigitDate + '_' + d.getHours() + "_" + d.getMinutes() + "_" + d.getSeconds();
                var elt = document.getElementById('general-table');
                var wb = XLSX.utils.table_to_book(elt, { sheet: "Sheet JS" });

                return XLSX.writeFile(wb, 'log_' + 'lista_campana' + '_' + date + '_.xlsx');
            },
        },
        mounted() {
            this.getCliente();
        }
    }
</script>
<style>
 .disponibles {
    display: flow-root !important;
 }
 .titulos-disponible {
    padding-left: initial !important;
    padding-right: initial !important;
 }

 .table thead>tr>th {
        font-size: 14px !important;
    }

    .table thead>tr>td {
        font-size: 10px !important;
    }


    .table-responsive {
        overflow:auto !important;
        width: 100%;
    }
</style>
